import React, { Component } from 'react'
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'

export class PreviewQuestionModal extends Component {

// constructor(props) {
//   super(props);
//   this.state = {
//     data: this.props.data
//   }
// }

convertToText = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
};

stringValue = (value) => {
  return value.toString();
}

render() {
  let questions = this.props.questions;
  let all_answers = this.props.all_answers;
  let question_images = this.props.question_images;
  let image_type = this.props.image_type;
  let topic = this.props.topic;
  let onSubmit = this.props.onSubmit;
  let handleModal = this.props.handleModal;

  return (
  
    <div className="modal modal-center fade" id="modal-question" tabindex="-1" >
        <div className="modal-dialog" style={{maxWidth: '60%'}} role="document">
        <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title">Preview question</h5>
            <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true" onClick={this.props.handleModal}>&times;</span>
            </button>
            </div>
            <div className="modal-body">

            <div className="card-body row">
              <div className="col-md-7">
                <div className="form-group">
                    <label className="require" for="input-required">Question </label><br />
                    {/* <h3 className='border-text'>{questions.name}</h3> */}
                    {/* <h3 className={topic[2].enable_box == true ? 'border-text' : ''}>  { topic[1].enable_bold == true ?  <b>{topic[0].question_topic}</b>  : topic[0].question_topic } </h3> */}
                    <h3 >{topic.question_topic}</h3>
                    <h3 >{questions.name? this.stringValue(questions.name) : ''}</h3>
                    {/* <h3>{questions.question} </h3> */}
                    <h3 >{questions.question ? this.convertToText(questions.question) : ''} </h3>
                    {/* <h3 className=''>{questions.question}</h3> */}
                    
                   <div className= {questions.full_sound_url ? '' : 'hidden'} >
                    <div className='center'>
                      {
                        questions.full_sound_url && <audio ref={(ref) => questions.sound_ref = ref} controls style={{width: '100%'}}> 
                        <source src={questions.full_sound_url} type="audio/mpeg"></source>
                      </audio>
                      }
                      {/* <audio ref={(ref) => questions.sound_ref = ref} controls style={{width: '100%'}}> 
                        <source src={questions.full_sound_url} type="audio/mpeg"></source>
                      </audio> */}
                    </div>
                  </div>

                    {/* <div className='center'>
                      <audio ref={(ref) => questions.sound_ref = ref} controls style={{width: '100%'}}> 
                        <source src={questions.full_sound_url} type="audio/mpeg"></source>
                      </audio>
                    </div> */}

                    {/* question_images.length && question_images.length == 4 && question_images.full_image_url && <img 
                      className="h-300px w-fullscreen" 
                      src={questions.full_image_url} 
                        /> 
                         */}
                    

                    <div className='row'>
                    {
                      questions.full_image_url && <img className="" src={questions.full_image_url} style={{cursor: 'pointer', aspectRatio: 9 / 16,  width: '100%', height: '300px'}}/>
                    }
                    {/* {
                      question_images && question_images !== ' ' && question_images.map((image, index) => {

                          if (image_type <= index) return <div/>;

                          return image.full_image_url && <div className={`col-md-${image_type == 1? "12" : "6"}`}>
                            <b className= {image_type == 1 ? 'hidden' : ''}>{index+1}.</b><img className="" src={image.full_image_url} style={{cursor: 'pointer', aspectRatio: 9 / 16,  width: '100%', height: `${image_type == 1?  "300px" : "150px"}`}}/>
                            <br /><br />
                          </div>
                        
                      })  
                    } */}
                    </div>      
                  </div>
                </div>  
              <div className="col-md-5">
                <div className="form-group">
                    <label className="require" for="input-required">Answer</label>
                    <div className='row'>

                {
                    all_answers.map((answer, index) => {
                      if (answer.full_image_url) return <div className="col-md-12 "> 
                          <div style={{marginTop: '0px',
                            // textAlign: 'center', 
                            // MaxHeight: '50px',
                            height: '100px'
                            }}>
                              <p className='circle'>{index+1}</p><img className="" src={answer.full_image_url} 
                              style={{cursor: 'pointer', maxWidth: '100%', 
                                maxHeight: '90%',
                                // height: 'auto',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                // display: 'block',
                                // margin: '0px auto'
                                marginTop: '-15px',
                                marginLeft: '50px'
                                }}/>
                                </div>
                          {/* <div style={{height: '140px'}}><p className='circle'>{index+1}</p><img className="" src={answer.full_image_url} style={{cursor: 'pointer', aspectRatio: 9 / 16,  width: '100%', height: '240px'}}/></div> */}
                          <br /><br />
                      </div>;  

                    return <div className='col-md-12'>
                        <div className='row'><p className='circle'>{index + 1}</p>&emsp;&emsp;&nbsp;<h4 style={{marginTop: 7}}> {answer.text} </h4></div>

                        {
                          answer.full_sound_url && <audio ref={(ref) => answer.ref = ref} controls style={{width: '100%'}}> 
                            <source src={answer.full_sound_url} type="audio/mpeg"></source>
                        </audio>
                        } 
                        

                    <br />
                  </div>
              })
              }

              </div>


                    
                </div>
              </div>
            </div>
            






            {/* <img className='center' src={deleteGif} width="900" height="350" /> */}
            </div>
            <div className="modal-footer">
            <button type="button" className="btn btn-bold btn-pure btn-secondary" data-dismiss="modal" id='dismissmodal' onClick={this.props.handleModal}>Close</button>
            <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={this.props.onSubmit}>Submit</button>
            {/* <button type="button" className="btn btn-bold btn-pure btn-primary" data-dismiss="modal" onClick={() => {
              // this.props.delete(data.id);
              document.getElementById('submit').click()

            }}>Submit</button> */}
            </div>
        </div>
        </div>
    </div>
  )
}
}

export default PreviewQuestionModal

